export default function Badge({ variant = 'primary', pill = false, children }) {
  return (
    <span className={`badge badge-${variant} ${pill && 'badge-pill'}`}>
      {children}
    </span>
  )
}
